'use es6';

import { createSelector } from 'reselect';
const getRssFeedUrlValidation = state => typeof state.get === 'function' ? state.get('rssFeedUrlValidation') : state.rssFeedUrlValidation;
export const getRssFeedUrlValidationResult = createSelector(getRssFeedUrlValidation, rssUrlFeedValidationResult => rssUrlFeedValidationResult && rssUrlFeedValidationResult.getData());
export const getRssFeedUrlValidationLoading = createSelector(getRssFeedUrlValidation, rssUrlFeedValidationResult => rssUrlFeedValidationResult.isLoading());